import { useQuery } from '@apollo/client';
import {
  WttpAllQuestionnaireQuestionsByQuestionnaireIdDocument,
  WttpAllQuestionnaireQuestionsByQuestionnaireIdQuery,
  WttpQuestionStatus,
  WttpQuestionnaireQuestionsByIdFilterInput,
} from 'src/graphql/generated/graphql';

export const useQuestionnaireQuestions = ({
  filter,
  page,
  paginationLimit,
  shouldSkip,
}: {
  filter?: WttpQuestionnaireQuestionsByIdFilterInput;
  page: number;
  paginationLimit: number;
  shouldSkip: boolean | undefined;
}) => {
  const { data, loading } =
    useQuery<WttpAllQuestionnaireQuestionsByQuestionnaireIdQuery>(
      WttpAllQuestionnaireQuestionsByQuestionnaireIdDocument,
      {
        variables: {
          filter: {
            wttpQuestionnaireId: filter?.wttpQuestionnaireId,
            question: {
              ...filter?.question,
              statuses: [WttpQuestionStatus.Active],
              isActive: true,
              categoryIds: filter?.question?.categoryIds?.length
                ? filter.question.categoryIds
                : undefined,
            },
          },
          sorting: {},
          pagination: {
            limit: paginationLimit,
            offset: page * paginationLimit,
          },
        },
        skip: shouldSkip,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-only',
      },
    );

  return {
    data: data,
    loading,
  };
};
